import * as React from 'react';
import { Typography, TypographyType } from '../typography';
import Icons from 'const/icons';
import { Icon } from '../icon';
import clsx from 'clsx';

interface AlertProps {
	type?: 'info' | 'error' | 'warning';
	typography?: TypographyType;
	text?: string | React.ReactNode;
	title?: string;
	titleClassName?: string;
	description?: string | React.ReactNode;
	className?: string;
	icon?: React.ReactElement;
	hideIcon?: boolean;
	classNameIcon?: string;
	classNameText?: string;
	classNameDescription?: string;
}

export const Alert: React.FC<AlertProps> = ({
	type = 'info',
	typography = 'regular-18',
	text,
	title,
	titleClassName,
	description,
	icon,
	hideIcon = false,
	className,
	classNameIcon,
	classNameText,
	classNameDescription,
}) => {
	const dirIcons = {
		info: (
			<Icon
				src={Icons.infoCircle}
				width={32}
				height={32}
				className={clsx(
					'text-main-blue-dark h-8 w-8 flex-shrink-0',
					classNameIcon
				)}
			/>
		),
		error: (
			<Icon
				src={Icons.closeCircle}
				className={clsx('text-main-red !size-6 flex-shrink-0', classNameIcon)}
			/>
		),
		warning: (
			<Icon
				src={Icons.yellowDanger}
				className={clsx('!size-6 flex-shrink-0', classNameIcon)}
			/>
		),
	};
	return (
		<div
			className={clsx(
				'flex items-start rounded-[20px] py-6 px-3 gap-4',
				{
					'bg-[#3957F41A] ': type === 'info',
					'bg-error-50': type === 'error',
					'bg-[#FD98341A] border border-main-orange shadow-sm':
						type === 'warning',
				},
				className
			)}
		>
			{!hideIcon && (icon || dirIcons[type])}
			<div className="flex flex-col gap-1">
				{title && (
					<Typography
						type="semibold-14"
						className={clsx(
							{
								'text-main-blue-dark': type === 'info',
								'text-main-red': type === 'error',
								'text-main-orange': type === 'warning',
							},
							titleClassName
						)}
					>
						{title}
					</Typography>
				)}
				{text &&
					(typeof text === 'string' ? (
						<Typography
							type={typography}
							className={clsx(
								{
									'text-main-blue-dark': type === 'info',
									'text-main-red': type === 'error',
									'text-main-orange': type === 'warning',
								},
								classNameText
							)}
						>
							{text}
						</Typography>
					) : (
						text
					))}
				{description &&
					(typeof description === 'string' ? (
						<Typography
							type="regular-14"
							className={clsx('text-grey-90', classNameDescription)}
						>
							{description}
						</Typography>
					) : (
						description
					))}
			</div>
		</div>
	);
};
